













































































































































































































































































































































































































































































































































import {Vue, Component} from "vue-property-decorator";
import HowToHeader from "@/components/HowToHeader.vue";
import HowToBody from "@/components/HowToBody.vue";
import RiskSubText from "@/components/RiskSubText.vue";
import {SurveyTabCollectionType} from "@/types/surveyComponent.type";

@Component({components: {HowToHeader, HowToBody, RiskSubText}})
export default class HowTo extends Vue {
    introText =
        "This tool is intended to help identify and prioritize risk to a State or Jurisdiction's election infrastructure and to identify mitigation options. In order to provide this Risk Profile, the user should respond to the questions in each election component page. Responses across components are transferred to the \"Risk Profile\" report which provides an overview of the component's high priority risk areas.";
    subText =
        'Likelihood is determined by the level of skill ("capability") an adversary requires to successfully attack an election system component (see below). Consequence is determined by the scale of impact of a cyberattack and the importance of such an attack in its impact on the ability of election officials to carry out election processes (see below).';

    get surveyTabs(): SurveyTabCollectionType {
        return this.$store.getters.surveyTabs;
    }
}
